<template>
  <div id="app">
    <!-- 路由占位符 -->
   <keep-alive :include="['Project']">
  <router-view/>
</keep-alive>
  </div>
</template>

<script>
export default {
  name: 'app'
}
</script>

<style lang="less" scoped>
/deep/ .el-dialog__body{
  padding: 10px;
}
/deep/ .el-dialog__header{
  padding: 20px 20px 0;
}
</style>
